import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import WHTransferReceive from 'components/Inventory/WarehouseTransferWmsReceive';

const WarehouseTransferWmsReceive = () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <WHTransferReceive />
      </SiteContent>
    </ContentLayout>
  );
};

export default WarehouseTransferWmsReceive;
